<div class="row">
  <div
    class="col-lg-6 col-md-6 col-sm-6 col-xs-10 col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-xs-offset-1">
    <form (ngSubmit)="onSubmit()" [formGroup]="resetInitialPasswordForm" autocomplete="off"
          class="wb-login__form">
      <div class="wb-login__form-sign wb-login__form-sign-login"></div>
      <div class="wb-login__form-title wb-reset-password__form-title">{{l10n('title')}}</div>
      <div class="wb-login__form-subtitle">{{l10n('resetInitialPasswordFormSubtitle')}}</div>
      <div *ngIf="warningLocalizationKey" class="warning-alert">
        <div class="warning-alert__sign"></div>
        <div class="warning-alert__message">{{l10n(warningLocalizationKey)}}</div>
      </div>
      <div *ngIf="isInitialPasswordExpired" class="warning-alert">
        <div class="warning-alert__sign"></div>
        <div class="warning-alert__message">{{l10n(initialPasswordExpiredErrorLsKey)}}</div>
      </div>
      <div class="form-group">
        <label [class.wb-login__label_invalid]="invalidPasswordFormat"
               for="newPassword" class="wb-login__label">{{l10n('newPassword')}}</label>
        <input id="newPassword"
               #newPasswordInput
               type="password"
               formControlName="newPassword"
               autocomplete="off"
               tabindex="2"
               [class.wb-login__input_invalid]="invalidPasswordFormat"
               [matTooltip]="l10n('invalidPasswordFormat')"
               [matTooltipDisabled]="!invalidPasswordFormat"
               [matTooltipClass]="'error-tooltip'"
               (focus)="isNewPasswordConfirmationOnScreenKeyboard ? switchNewPasswordOnscreenKeyboard() : null"
               (keyup)="invalidPasswordFormat = false"
               class="form-control wb-login__input">
        <div [class.active]="isNewPasswordOnScreenKeyboard"
             (click)="switchNewPasswordOnscreenKeyboard()" class="wb-login__keyboard-icon"></div>
      </div>
      <div class="form-group">
        <label [class.wb-login__label_invalid]="invalidPasswordConfirmation"
               for="newPasswordConfirmation"
               class="wb-login__label">{{l10n('confirmNewPassword')}}</label>
        <input id="newPasswordConfirmation"
               #newPasswordConfirmationInput
               type="password"
               formControlName="newPasswordConfirmation"
               autocomplete="off"
               tabindex="2"
               [class.wb-login__input_invalid]="invalidPasswordConfirmation"
               [matTooltip]="l10n('passwordConfirmationError')"
               [matTooltipDisabled]="!invalidPasswordConfirmation"
               [matTooltipClass]="'error-tooltip'"
               (focus)="isNewPasswordOnScreenKeyboard ? switchNewPasswordConfirmationOnscreenKeyboard() : null"
               (keyup)="invalidPasswordConfirmation = false"
               class="form-control wb-login__input">
        <div [class.active]="isNewPasswordConfirmationOnScreenKeyboard"
             (click)="switchNewPasswordConfirmationOnscreenKeyboard()"
             class="wb-login__keyboard-icon"></div>
        <onscreen-keyboard *ngIf="isNewPasswordOnScreenKeyboard" [form]="resetInitialPasswordForm"
                           [inputName]="'newPassword'"
                           (onReturnPress)="onSubmit()"></onscreen-keyboard>
        <onscreen-keyboard *ngIf="isNewPasswordConfirmationOnScreenKeyboard"
                           [form]="resetInitialPasswordForm" [inputName]="'newPasswordConfirmation'"
                           (onReturnPress)="onSubmit()"></onscreen-keyboard>
      </div>
      <div [innerHTML]="'ls_set_password_message' | l10n"
           class="wb-login__info ic__info_md-gray"></div>
      <auth-button id="auth-button"
                   [isDisabled]="(isResetInitialPasswordProcess$ | async) || resetInitialPasswordForm.invalid"
                   [caption]="!(isResetInitialPasswordProcess$ | async) ? l10n('saveAndContinue') : l10n('saving')"
                   [showLoader]="(isResetInitialPasswordProcess$ | async)"
                   [buttonType]="'submit'"></auth-button>
    </form>
  </div>
</div>
